import React, { useState, useEffect } from "react";

import ClubbieModal from "../../../Modal/ClubbieModal";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";

const BracketMatchModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  bracketName = "",
  initialData = { name: "" },
}) => {
  const [formData, setFormData] = useState({
    name: "",
  });

  useEffect(() => {
    if (isOpen) {
      setFormData({
        name: initialData.name || "",
      });
    }
    // Only depend on isOpen to prevent infinite update loops
  }, [isOpen]);

  const handleSubmit = () => {
    // Validate form
    if (!formData.name.trim()) {
      return;
    }
    
    // Submit data to parent component
    onSubmit({
      name: formData.name.trim(),
    });
  };

  const handleClose = () => {
    setFormData({
      name: "",
    });
    onClose();
  };

  return (
    <ClubbieModal
      isOpen={isOpen}
      width="500px"
      toggle={handleClose}
      title={`Add match in ${bracketName || "bracket"}`}
    >
      <div className="space-y-5 p-1">
        {/* Match Name Input */}
        <div className="space-y-2">
          <label className="block text-[14px] font-normal text-app-text mb-1.5 ">
            Match name
          </label>
          <input
            type="text"
            className="w-full h-12 px-4 bg-app-surface border border-app-surface rounded-full text-[14px] text-[#FEFCEB] placeholder-app-text-secondary font-proxima focus:outline-none focus:border-[#00E7FF] transition-colors"
            value={formData.name}
            placeholder="e.g. Match A1, Quarter Final 1"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            className="px-6 py-2.5 rounded-full bg-[#0A1929] text-[#FEFCEB] text-sm font-medium hover:bg-[#0D1B29] transition-colors"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-6 py-2.5 rounded-full bg-[#00BCD2] text-[#081725] text-sm font-medium hover:bg-[#00E7FF] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            onClick={handleSubmit}
            disabled={isLoading || !formData.name.trim()}
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="small" />
                <span>Creating...</span>
              </>
            ) : (
              "Create"
            )}
          </button>
        </div>
      </div>
    </ClubbieModal>
  );
};

export default BracketMatchModal;
